var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap_content"},[_c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)],1),_c('a-config-provider',{attrs:{"locale":_vm.locale}},[(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }